// src/context/UserContext.jsx
import { createContext, useContext } from "react";
import { useAuth } from "../auth/useAuth";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const { user } = useAuth();
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
